import { render } from "./1DataUmum.vue?vue&type=template&id=121449b6"
import script from "./1DataUmum.vue?vue&type=script&lang=js"
export * from "./1DataUmum.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__